<template>
  <Modal :value="isShow" class="doingModalBox" :mask-closable="false" :closable="false" class-name="vertical-center-modal">
    <span slot="header"></span>
    <div class="modal-content">
      <div class="modal-content-wrap">
        <div class="timeline">
          <Row>
            <Col span="8" :class="{rvc: true, active: index > 0}">
              <div :class="{line: true, active: index > 1}"></div>
              <div class="point"></div>
              <div class="desc">原产地判定标准</div>
              <div class="name">RVC</div>
            </Col>
            <Col span="8" :class="{ctc: true, active: index > 1}">
              <div :class="{line: true, line1: true, active: index > 1}"></div>
              <div :class="{line: true, line2: true, active: index > 2}"></div>
              <div class="point"></div>
              <div class="desc">原产地判定标准</div>
              <div class="name">CTC</div>
            </Col>
            <Col span="8" :class="{other: true, active: index > 2}">
              <div :class="{line: true, active: index > 2}"></div>
              <div class="point"></div>
              <div class="desc">其他判定标准</div>
            </Col>
          </Row>
        </div>
        <div class="tips">
          <div class="wrap">
            <img src="~@/assets/images/coo/icon_shijian.png" alt="">
            <span>原产地规则判定中...</span>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer"></div>
  </Modal>
</template>

<script>
export default {
  name: 'DoingModal',
  props: {
    isShow: {
      type: Boolean,
      default: false,
      required: false
    },
    index: {
      type: Number,
      default: 0,
      required: false
    }
  }
}
</script>
<style scoped>
  @media print,screen and (min-width:1366px) {
    .doingModalBox >>> .vertical-center-modal,
    .doingModalBox >>> .ivu-modal{
      width: 580px !important;
      margin: 0 auto;
    }
  }
  @media print,screen and (max-width:1365px) {
    .doingModalBox >>> .vertical-center-modal,
    .doingModalBox >>> .ivu-modal{
      width: 580px !important;
      margin: 0 auto;
    }
  }
  .doingModalBox >>> .loading .wrap{
    top: 36px;
  }
  .doingModalBox >>> .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: -100px;
  }
  .doingModalBox >>> .vertical-center-modal .ivu-modal{
    top: 0;
  }
  .doingModalBox >>> .ivu-modal-header{
    display: none;
  }
  .doingModalBox >>> .ivu-modal-footer{
    display: none;
  }
  .timeline{
    margin-top: 50px;
    margin-bottom: 20px;
    color: #333;
    font-size: 15px;
    text-align: center;
  }
  .timeline >>> .ivu-col{
    position: relative;
  }
  .timeline .point{
    background: url("~@/assets/images/coo/icon_chenggong2.png") 0 0 no-repeat transparent;
    background-color: #fff;
    background-size: 16px 16px;
    width: 16px;
    height: 16px;
    position: absolute;
    top: -26px;
    z-index: 2;
  }
  .timeline .active .point{
    background-image: url("~@/assets/images/coo/icon_chenggong.png");
  }
  .timeline .line{
    width: 100%;
    height: 2px;
    background-color: #F1F1F1;
    position: absolute;
    top: -20px;
    z-index: 1;
  }
  .timeline .line.active{
    background-color: #1F8AFD;
  }
  .timeline .rvc .line{
    width: 50%;
    right: 0;
  }
  .timeline .ctc .line{
    width: 50%;
  }
  .timeline .ctc .line1{
    left: 0;
  }
  .timeline .ctc .line2{
    right: 0;
  }
  .timeline .rvc .point,
  .timeline .ctc .point,
  .timeline .other .point{
    left: 50%;
    margin-left: -8px;
  }
  .timeline .other .line{
    width: 50%;
    left: 0;
  }
  .tips{
    text-align: center;
    color: #999;
    font-size: 15px;
    margin-bottom: 10px;
  }
  .tips .wrap{
    position: relative;
    display: inline-block;
    padding-left: 20px;
  }
  .tips img{
    /*width: auto;*/
    height: 14px;
    /*display: inline-block;*/
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -6px;
    -webkit-transform: rotate(360deg);
    animation: rotation 1.2s linear infinite;
    -moz-animation: rotation 1.2s linear infinite;
    -webkit-animation: rotation 1.2s linear infinite;
    -o-animation: rotation 1.2s linear infinite;
  }
  .tips span{
    /*display: inline-block;*/
    /*height: 15px;*/
    /*line-height: 15px;*/
    /*vertical-align: top;*/
    /*padding-left: 2px;*/
  }
  @keyframes rotation{
    from {-webkit-transform: rotate(0deg);}
    to {-webkit-transform: rotate(360deg);}
  }
  @-webkit-keyframes rotation{
    from {-webkit-transform: rotate(0deg);}
    to {-webkit-transform: rotate(360deg);}
  }
  @-moz-keyframes rotation{
    from {-webkit-transform: rotate(0deg);}
    to {-webkit-transform: rotate(360deg);}
  }
  @-o-keyframes rotation{
    from {-webkit-transform: rotate(0deg);}
    to {-webkit-transform: rotate(360deg);}
  }
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/doingModal.vue